import "./App.css";
import SideNav from "./Components/SideNav/SideNav";
import Navbar from "./Components/Navbar/Navbar";
import Complaint from "./Components/Complaint/Complaint";
import SignIn from "./Pages/SignIn page/SignIn";
import SignUp from "./Pages/SignUp/SignUp";
import AuthProvider from "./Context/UseAuthContext";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute/ProtectedRoute";
import Dashboard from "./Components/Dashoard/Dashboard";
import Status from "./Components/Status/Status";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            exact
            element={
              <ProtectedRoute>
                <Complaint />
              </ProtectedRoute>
            }
          />
          <Route path="/logIn" exact element={<SignIn />} />
          <Route path="/signUp" exact element={<SignUp />} />
          <Route path="/dashboard" exact element={<Dashboard />} />
          <Route path="/status" exact element={<Status />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
